import React from 'react'
import { List, MinimalistTitle } from '@wallyhealth/web-core'
import styles from './index.module.css'

const CareTips = () => (
  <div className={styles.container}>
    <MinimalistTitle
      className={styles.title}
      title="Wear & Care"
    />
    <List
      className={styles.list}
      items={[
        {
          label: 'Perform your nightly oral care routine of brushing & flossing.',
          icon: (
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_57_1355)">
                <path d="M17.5 -0.418823L23.6872 10.894L35 17.0812L23.6872 23.2684L17.5 34.5812L11.3128 23.2684L0 17.0812L11.3128 10.894L17.5 -0.418823Z" fill="black"/>
              </g>
              <defs>
                <clipPath id="clip0_57_1355">
                  <rect width="35" height="35" fill="white" transform="translate(0.5 0.0811768)"/>
                </clipPath>
              </defs>
            </svg>
          )
        },
        {
          label: 'Wet your guard slightly and then place the guard on your teeth.',
          icon: (
            <svg width="36" height="35" viewBox="0 0 36 35" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M30.425 20.6071C30.425 28.4475 24.8621 32.453 18 32.453C11.1378 32.453 5.57495 28.4475 5.57495 20.6071C5.57495 12.7667 18 2.54712 18 2.54712C18 2.54712 30.425 12.7667 30.425 20.6071Z" fill="black"/>
            </svg>
          )
        },
        {
          label: 'Wear overnight and if you notice pain or discomfort the next morning, please reach out to your care team.',
          icon: (
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_57_1342)">
                <path d="M24.9189 10.6622H35.5V24.6622H24.9189V35.0812H10.9189V24.6622H0.5V10.6622H10.9189V0.0811768H24.9189V10.6622Z" fill="black"/>
              </g>
              <defs>
                <clipPath id="clip0_57_1342">
                  <rect width="35" height="35" fill="white" transform="translate(0.5 0.0811768)"/>
                </clipPath>
              </defs>
            </svg>
          )
        },
        {
          label: 'Clean your guard with warm soapy water & dry to store. Never use toothpastes which can create scratches that harbor bacteria.',
          icon: (
            <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.0811 1.76848C26.3907 0.661734 31.5239 4.67157 32.5459 10.7245C32.9951 13.3846 32.5739 15.9961 31.5117 18.1825C32.2247 19.2679 32.7426 20.554 32.9834 21.9804C33.8053 26.8488 31.1136 31.4949 26.9717 32.3583C25.0329 32.7624 23.1197 32.2667 21.5489 31.1249C20.5468 32.7898 18.9565 34.0288 17.0293 34.4306C13.2657 35.2151 9.65123 32.5145 8.95608 28.3984C8.85667 27.8095 8.82341 27.2234 8.84866 26.6493C5.51422 26.323 2.707 23.8149 2.11038 20.2812C1.57167 17.0895 2.98711 13.9521 5.47757 12.1611C5.26237 11.6824 5.10368 11.1683 5.01175 10.6239C4.40078 7.00527 6.94816 3.43688 10.7022 2.65422C12.9361 2.18859 15.0937 2.81467 16.6035 4.16008C17.8457 2.97367 19.3673 2.12572 21.0811 1.76848Z" fill="black"/>
            </svg>
          )
        }
      ]}
    />
  </div>
)

export default CareTips
